var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSwapIconWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_2947",
    "data-name": "Groupe 2947",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.84,
    height: 20.062,
    viewBox: "0 0 16.84 20.062",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2014",
    "data-name": "Trac\\xE9 2014",
    d: "M-180.557,2719.641a1.51,1.51,0,0,0,1.51-1.51,1.51,1.51,0,0,0-1.51-1.51h-2.461a4.158,4.158,0,0,1-3.25-1.561,4.217,4.217,0,0,1-.815-3.564,4.284,4.284,0,0,1,4.256-3.215h2.27a1.51,1.51,0,0,0,1.51-1.51,1.51,1.51,0,0,0-1.51-1.51h-2.27a7.319,7.319,0,0,0-7.207,5.591,7.223,7.223,0,0,0,1.413,6.1,7.163,7.163,0,0,0,5.6,2.688Z",
    transform: "translate(190.206 -2705.26)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2015",
    "data-name": "Trac\\xE9 2015",
    d: "M-152.417,2736.161a7.163,7.163,0,0,0-5.6-2.688h-2.461a1.51,1.51,0,0,0-1.51,1.51,1.51,1.51,0,0,0,1.51,1.51h2.461a4.157,4.157,0,0,1,3.25,1.561,4.218,4.218,0,0,1,.815,3.564,4.285,4.285,0,0,1-4.256,3.215h-2.27a1.51,1.51,0,0,0-1.51,1.51,1.51,1.51,0,0,0,1.51,1.51h2.27a7.32,7.32,0,0,0,7.207-5.591A7.225,7.225,0,0,0-152.417,2736.161Z",
    transform: "translate(167.672 -2727.792)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapIconWhite);
export default __webpack_public_path__ + "static/media/swapIconWhite.950c6a42b2b0f88a82a77747f18ae63d.svg";
export { ForwardRef as ReactComponent };